import axiosInstance from "./axiosInstance";
import { ENDPOINTS } from "./endpoints";

export const getGlobalSettings = async (locale = "en") => {
  const res = await axiosInstance.get(
    `${ENDPOINTS.GLOBAL_SETTINGS}?locale=${locale}&populate=logo`
  );
  return res.data.data; // ARRAY
};
